<template>
  <div id="main-content" class="login">
    <header-vue />
    <main-vue />
    <footer-vue />
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import MainVue from "./Main.vue";
import FooterVue from "./Footer.vue";
import { mapMutations } from "vuex";

export default {
  components: {
    HeaderVue,
    MainVue,
    FooterVue
  },
  methods: {
    ...mapMutations("portalemail", {
      clearEmailState: "clearState"
    })
  },
  async created() {
    this.clearEmailState();
  }
};
</script>

<style scoped>
body,
html {
  font-family: Verdana, Geneva, Arial, helvetica, sans-serif;
  font-size: 16px;
  color: #333;
  height: 100%;
  z-index: 1;
  line-height: 1;
}

#main-content {
  color: inherit;
  min-height: 100vh !important;
  height: auto !important;
  margin: 0 auto -3em;
  overflow: hidden;
  position: relative;
}
</style>
